module.exports = __webpack_public_path__ + "img/ima03.5eba746d.jpg";